import { z } from "zod";

/**
 * Mirrors `CoverageBetaQaReason` (types/coverage.ts) — kept in sync manually,
 * same as the rest of this schema file mirrors its result-type counterpart.
 */
const CoverageBetaQaReasonSchema = z.enum([
  "not_empty_area",
  "product_match",
  "remaining_product_facings",
  "blue_tag_present",
  "not_main_aisle",
  "incorrect_removal",
  "not_unblurred_person",
]);

/** Mirrors `CoverageBetaQaBoxKind` (types/coverage.ts). */
const CoverageBetaQaBoxKindSchema = z.enum([
  "oos_confirmed",
  "empty_area",
  "unblurred_person",
  "deleted",
]);

/** Mirrors `CoverageBetaQaVerdict` (types/coverage.ts). */
const CoverageBetaQaVerdictSchema = z.enum(["confirmed", "incorrect"]);

const CoverageBetaQaBoxVerdictSchema = z.object({
  kind: CoverageBetaQaBoxKindSchema,
  index: z.number().int(),
  qa_verdict: CoverageBetaQaVerdictSchema,
  incorrect_reasons: z.array(CoverageBetaQaReasonSchema),
  note: z.string().nullable(),
});

const CoverageBetaQaResultSchema = z.object({
  boxes: z.array(CoverageBetaQaBoxVerdictSchema),
  unblurred_persons_missed: z.boolean(),
  boxes_that_should_have_been_drawn: z.number().int().nonnegative(),
  qa_feedback: z.string().nullable(),
  flag_labeler: z.boolean(),
});

export const CompleteCoverageBetaQaPayloadSchema = z.object({
  result: CoverageBetaQaResultSchema,
});

export type CompleteCoverageBetaQaPayloadSchemaType = z.infer<
  typeof CompleteCoverageBetaQaPayloadSchema
>;
